import type { MouseEvent } from 'react';
import styles from './index.module.less';
import type { Theme, Tools } from '../../../core/types';
import { Size } from '../../../core/enums';
import withEventTracking from '../../../utilities/withEventTracking';
import { Icon } from '../../atoms/icon';
import Element from '../../../core/Element';

interface ClickableProps {
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  imageName?: string;
  directory?: string;
  $size?: Size;
  theme?: Theme;
  qeId?: string;
  tools?: Tools;
  children?: React.ReactNode;
  ariaLabel: string;
  expanded?: boolean;
}

const IconButton = ({
  onClick = () => {},
  imageName = 'dls-glyph-info',
  directory = 'dls',
  $size = Size.SM,
  theme = {},
  qeId = 'icon-button',
  ariaLabel,
  expanded = false,
  ...props
}: ClickableProps) => (
  <Element
    Component="button"
    type="button"
    aria-expanded={expanded}
    className={styles.root}
    onClick={onClick}
    aria-label={ariaLabel}
    {...props}
  >
    <Icon
      imageName={imageName}
      directory={directory}
      qeId={qeId}
      $size={$size}
      theme={theme}
    />
  </Element>
);

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to the [DLS Icon Button component](https://design.aexp.com/components/actions/https://design.aexp.com/components/actions/icon-button/overviewicon-button/overview)
 */
export default withEventTracking<ClickableProps>(IconButton);
